import { render, staticRenderFns } from "./CreateOrEditRule.vue?vue&type=template&id=5d4c7a9b&scoped=true"
import script from "./CreateOrEditRule.vue?vue&type=script&lang=js"
export * from "./CreateOrEditRule.vue?vue&type=script&lang=js"
import style0 from "./CreateOrEditRule.vue?vue&type=style&index=0&id=5d4c7a9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c7a9b",
  null
  
)

export default component.exports